// companySlice.js
import { createSlice } from '@reduxjs/toolkit';

const UserSlice = createSlice({
  name: 'user',
  initialState: {
    userData: null,
    isSignedIn: false,
  },
  reducers: {
    setSignedIn: (state, action) => {
      state.isSignedIn = action.payload;
    },
    setUserData: (state, action) => {
      state.userData = action.payload
    },
    logout: (state, action) => {
      // console.log('sdlknfsdklf==', action.payload)
      state.userData = action.payload.userData
      state.isSignedIn = action.payload.isSignedIn
    }
  },
});

export const { setSignedIn, setUserData, logout } = UserSlice.actions;

export const selectSignedIn = (state) => state.user.isSignedIn;
export const selectUserData = (state) => state.user.userData;

export default UserSlice.reducer;
